import React from "react";
import styles from "./About.module.css"; // Import CSS Module

const About = () => {
  return (
    <section className={styles.aboutSection} id="about">
      <div className={styles.aboutContainer}>
        <div className={styles.aboutContent}>
          <h2 className={styles.aboutTitle}>Welcome to ImageCompressor</h2>
          <p className={styles.aboutDescription}>
            Your source for live and easy image optimization and conversions
            without loss in quality. In the age of the internet, it is important
            to have your images properly formatted and compressed for better
            SEO, user experience, and bandwidth. Our toolset is designed to
            enable designers, developers, and content creators to easily
            optimize their images without sacrificing their visual quality.
          </p>

          <p className={styles.aboutDescription}>
            Our leading-edge browser-based application technology is fully
            preferable because any processing of your files happens locally,
            ensuring your privacy and security. We will never upload your images
            to a server, and your information will never leave your device.
            Whether you are exporting assets for a website, mobile app, social
            media, or email campaign, our toolsets can help anyone make quality
            professional images with ease.
          </p>

          <div className={styles.aboutFeatures}>
            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>🔄</div>
              <h3>Smart Format Switching</h3>
              <p>
                Switch between JPG, PNG, and WEBP image formats with upward of
                30 formats. Our intelligent algorithms take advantage of and
                identify the best format compression for your results.
              </p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>⚡</div>
              <h3>Almost Instant Conversion</h3>
              <p>
                Utilizing advanced WebAssembly and JavaScript allows for almost
                instant conversion and compression, even with higher-resolution
                images. Image batches will be processed in seconds, not minutes.
              </p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>🔒</div>
              <h3>Privacy at the Government Level</h3>
              <p>
                All processing happens 100% in the browser. We will not hold,
                track, or analyze your files—unlike cloud-based providers that
                retain your data.
              </p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>🎨</div>
              <h3>Format Control</h3>
              <p>
                There are settings for each individual format: JPEG quality, PNG
                transparency, and WEBP animation/compression type. Compare your
                optimized image side by side with the original before
                downloading.
              </p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>📱</div>
              <h3>Supported Formats</h3>
              <p>
                Supports all current formats: JPEG, PNG, WEBP, and more. Works
                seamlessly across desktop and mobile devices.
              </p>
            </div>

            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>🖼️</div>
              <h3>Bulk Processing</h3>
              <p>
                Convert and compress files in bulk in the same or separate
                formats in one go, saving time when preparing large image
                collections.
              </p>
            </div>
          </div>

          <div className={styles.techDetails}>
            <h3>Behind the Technology:</h3>
            <ul>
              <li>Canvas API for lossy conversion and format processing</li>
              <li>WebAssembly image processing engine</li>
              <li>Quality resampling via Lanczos</li>
              <li>Web Workers for multi-threaded processing</li>
              <li>Progressive processing for large files</li>
              <li>Automatic color profile handling</li>
              <li>Option to preserve metadata</li>
            </ul>
          </div>

          <div className={styles.useCases}>
            <h3>Common Use Cases:</h3>
            <div className={styles.useCaseGrid}>
              <div className={styles.useCase}>
                <h4>Web Development</h4>
                <p>
                  Convert PNGs to WEBP to reduce file size while preserving
                  transparency.
                </p>
              </div>
              <div className={styles.useCase}>
                <h4>Social Media</h4>
                <p>
                  Save, export, and compress JPGs optimized for social media
                  platforms.
                </p>
              </div>
              <div className={styles.useCase}>
                <h4>E-Commerce</h4>
                <p>
                  Process large numbers of product images into consistent
                  formats and sizes.
                </p>
              </div>
              <div className={styles.useCase}>
                <h4>Mobile Apps</h4>
                <p>
                  Create assets for Android and iOS in multiple resolutions and
                  formats.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
